import ProjectItem from '../components/ProjectItem';
import projectsData from '../data/projectsData';

function Landed() {
  const galleryItems = projectsData.filter((p) => ['ttdi-01', 'maluri-02'].includes(p.id));

  return (
    <section className="gallery">
      <div className="projects-container">
        <h1 className="category-title">Landed</h1>
        <div className="projects-container">
          <div className="projects-main">
            <div className="category-grid">
              {galleryItems.map((item) => (
                <ProjectItem
                  key={item.id}
                  id={item.id}
                  image={item.titleImage}
                  title={item.title}
                />
              ))}
            </div>
          </div>
        </div>
      </div>  
    </section>
  );
}

export default Landed;